import { v4 as uuidv4 } from "uuid";

import { TSectionPage, TemplatePageType } from "models";
import { defaultCoverPage } from "./default-cover-sheet";

/**
 * Every document must contain three mandatory sections:
 *   - coverPage    (TipTap-edited; seeded with the default cover when created)
 *   - contentsPage (not TipTap-edited)
 *   - defectList   (not TipTap-edited)
 *
 * Custom sections are inserted/reordered around these. This guarantees all three
 * are present, returning a NEW array (the input is not mutated). Used on document
 * create/load (loadTemplate) and intended for the gallery apply flow so the
 * guarantee lives in one tested place.
 *
 * A missing cover page is prepended (covers must lead); contents/defect list are
 * appended if missing.
 */
export function ensureMandatorySections(pages: TSectionPage[]): TSectionPage[] {
  const result = [...pages];

  if (!result.find((o) => o.type === TemplatePageType.coverPage)) {
    result.unshift({ id: uuidv4(), type: TemplatePageType.coverPage, content: structuredClone(defaultCoverPage) });
  }

  if (!result.find((o) => o.type === TemplatePageType.contentsPage)) {
    result.push({ id: uuidv4(), type: TemplatePageType.contentsPage, content: [] });
  }

  if (!result.find((o) => o.type === TemplatePageType.defectList)) {
    result.push({ id: uuidv4(), type: TemplatePageType.defectList, content: [] });
  }

  return result;
}
